<template>
<footer class="admin-footer">
	<template v-if="getDevNote">
		<div class="dev-note">{{ getDevNote }}</div>
	</template>
	<template v-else>
		© {{ year }} Connected Data Solutions&nbsp;•&nbsp; v{{ getAppVersion }}
		<span  v-if="getUser.user_type_code">
			&nbsp;•&nbsp; <router-link to="/terms-of-use">Terms of Use</router-link>
			&nbsp;•&nbsp; <router-link to="/legacy/datacenter.php">Data Center</router-link>
			&nbsp;•&nbsp; <router-link to="/help-center">Help Center</router-link>
		</span>
		&nbsp;•&nbsp; <span class="note">{{ getServerName }}</span>
	</template>
</footer>
</template>

<script>
export default {
	name: 'cds-footer',
	data() {
		return {
			year: ''
		}
	},
	created() {
		let d = new Date();
		this.year = (d.getYear() + 1900)
	}
}
</script>
